// === frontend/src/services/api.js ===
import axios from 'axios';

// 1. Grab the primary environment variable
let customBaseURL = process.env.REACT_APP_API_URL;

// 2. Catch empty variables AND literal "undefined" strings
if (!customBaseURL || customBaseURL === 'undefined') {
    // If it's the JB Marks UI, force the JB Marks API
    if (process.env.REACT_APP_TENANT === 'JBMARKS') {
        customBaseURL = 'https://jbmarks-api-520983012715.africa-south1.run.app/api';
    } else {
        // Otherwise, fall back to BrightSparc
        customBaseURL = 'https://brightsparc-api-520983012715.africa-south1.run.app/api';
    }
}

// 3. Create the Axios instance using ONLY our safe customBaseURL
const api = axios.create({
    baseURL: customBaseURL,
    // 🚀 THE FIX: Force Axios to send and receive cross-domain cookies
    withCredentials: true, 
    headers: {
        'Content-Type': 'application/json'
    }
});

// 4. REQUEST INTERCEPTOR: Automatically attach the token to every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 5. 🚨 RESPONSE INTERCEPTOR: The "Zombie Token" Killer (Updated for 401 & 403)
// === frontend/src/services/api.js ===

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;
            const msg = error.response.data?.message || '';

            // 🚨 ONLY kick out and destroy session if the token is explicitly EXPIRED or INVALID (401)
            if (status === 401) {
                console.warn("[AUTH INTERCEPTOR] Token expired or invalid. Clearing session...");
                
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                sessionStorage.clear();
                
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login?expired=true';
                }
            } 
            
            // 🚨 For 403 (Forbidden), DO NOT wipe the token! Just log it or let the component handle it.
            if (status === 403) {
                console.error("[AUTH INTERCEPTOR] Access forbidden for this resource:", error.config.url);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
